import IComponentOptions = angular.IComponentOptions;
import ILogService = angular.ILogService;
import ITimeoutService = angular.ITimeoutService;
import ITranslateService = angular.translate.ITranslateService;
import {IStateService} from 'angular-ui-router';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import TSBenutzer from '../../../models/TSBenutzer';
import TSPasswordData from '../../../models/TSPasswordData';
import {IAuthenticationStateParams, IVerfivyParams} from '../../authentication.route';
import AuthServiceRS from '../../service/AuthServiceRS.rest';

require('./verifyView.scss');
let template = require('./verifyView.html');

export class VerifyComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = VerifyViewController;
    controllerAs = 'vm';
}

export class VerifyViewController {

    static $inject: string[] = ['$state', '$stateParams', 'BenutzerRS',
        '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'AuthServiceRS'];

    private model: TSPasswordData;

    constructor(private $state: IStateService, private $stateParams: IVerfivyParams,
                private benutzerRS: BenutzerRS,
                private $log: ILogService, private errorService: ErrorService, private CONSTANTS: any,
                private $translate: ITranslateService, private $timeout: ITimeoutService, private authService: AuthServiceRS) {

    }

    $onInit() {
        let benutzerid = this.$stateParams.verifyBenutzer || '';
        this.$log.debug('verifying benutzer with id ' + benutzerid);
        this.benutzerRS.verify(benutzerid).then((response: TSBenutzer) => {
                this.errorService.addMesageAsInfo('EMAIL_VERIFIED');
                if (this.authService.isLoggedId()) {
                    //wenn schon eingeloggt auf startseite weiterlieten (sollte wohl nicht vorkommen)
                    this.authService.logoutRequest().then(() => {
                        this.$log.debug('logout successfull');
                        this.loginWithResponse(response);
                    });
                }
                this.loginWithResponse(response);
            }
        ).catch((reason: any) => {
            this.$log.debug('Email verification failed');
        });
        this.errorService.clearAll();
    }

    private loginWithResponse(response: TSBenutzer) {
        //auf loginseite weiterleiten
        let params = new IAuthenticationStateParams();
        params.userID = (response && response.email) ? response.email : '';
        this.$state.go('login', params);
    }

    public back(): void {
        this.$state.go('start');  // going back to start
    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/component/verifyView/verifyView.ts